import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ContentProvider } from "./context/ContentContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Promotions from "./components/Promotions";
import Pricing from "./components/Pricing";
import Team from "./components/Team";
import Locations from "./components/Locations";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BeforeAfter from "./pages/BeforeAfter";
import Admin from "./pages/Admin";

function Home() {
  return (
    <div className="App bg-[#F7F2EA]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Promotions />
        <Pricing />
        <Team />
        <Locations />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/before-after" element={<BeforeAfter />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
